import React, { useEffect, useState } from "react";
import Layout from "@layouts/withoutNaviagtion/withoutNavigationLayout";
import { Pagination, PaginationItem, PaginationLink, } from "reactstrap";
import { NavLink } from "react-router-dom";
import "./VendorHistory.scss";

import VendorHistoryTable from "./VendorHistoryTable/VendorHistoryTable";
import ReleasePagination from "../../RelasePagination/ReleasePagination";
import { useNavigate } from "react-router-dom";
import { convertCurrentDate, convertDate } from "@_common/date-helpers";
import { QueryRequestHelper } from "@_common/query-request-helper";
import { getValue } from "@utils/lodash";
import { GetSpecificLocationHistory } from "@services/checkpoint.service";
import { useParams } from "react-router-dom";
import ScrollableReactTable from "@components/ScrollableDatatable";
import { formatText } from "@_common/format-text";
import PaginationPage from "@components/pagination/pagination";



function VendorHistory(props: any) {
    let mainParams = useParams();

    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
  
    const navigate = useNavigate();
  
    const [vendorHistoryList, setVendorHistoryList] = useState([]);
    const [isLoading, setIsLoading] = React.useState(true);

    const [vendorName, setVendorName] = useState<any>([]);
    const [locationName, setLocationName] = useState<any>([]);
    useEffect(() => {
        //  const contentState = convertFromRaw(content);
    
        const urlSearchParams = new URLSearchParams(window.location.search);
        const params = Object.fromEntries(urlSearchParams.entries());
        if (Object.keys(params).length === 0 && props.permissionAPITriggered) {
          getData();
        }
      }, [props.permissionAPITriggered]);
    
      useEffect(() => {
        const urlSearchParams = new URLSearchParams(window.location.search);
        const params = Object.fromEntries(urlSearchParams.entries());
        if (Object.keys(params).length > 0 && props.permissionAPITriggered) {
          getData();
        }
      }, [window.location.href, props.permissionAPITriggered]);
    
      const getData = async () => {
        const urlSearchParams = new URLSearchParams(window.location.search);
        const params = Object.fromEntries(urlSearchParams.entries());
        let dates = params.date ? new Date(params.date) : new Date();
        var from_date = params.from_date
          ? params.from_date
          : new Date(dates.getFullYear(), dates.getMonth(), 1);
        var to_date = params.to_date
          ? params.to_date
          : new Date(dates.getFullYear(), dates.getMonth() + 1, 0);
        try {
          let payload = {
            page_no: params.page_no ? parseInt(params.page_no) : 1,
            page_size: params.limit ? parseInt(params.limit) : limit,
            search_text: params.search_text,
            // from_date: convertDate(from_date),
            // to_date: convertDate(to_date),
            
          };
          let queryRequest = QueryRequestHelper(payload);
          setIsLoading(true);
          let resp = await GetSpecificLocationHistory(getValue(mainParams,`id`,""),queryRequest);
          if (resp) {
            setVendorHistoryList(
              getValue(resp, `data.release_dates_history`, []).map((item: object) => ({
                ...item,
                start_date: convertCurrentDate(getValue(item,`start_date`,"")),
                cutoff_date: convertCurrentDate(getValue(item,`cutoff_date`,"")),
                addedBy: getValue(item,`created_by.first_name`,"") + getValue(item,`created_by.last_name`,""),
                created_at: convertCurrentDate(getValue(item, `created_at`, "")),
                updated_at: convertCurrentDate(getValue(item, `updated_at`, "")),
                release_cycle: "Release " + getValue(item, `release_date_audit_cycle.cycle`, ""),
                // action: 
            }))
            );

            const vendorName = getValue(
              resp, 
              `data.release_dates_history[${0}].release_date_audit_cycle.release_date_location.release_date.vendor.vendor_name`, 
              ""
            );

            const locationName = getValue(
              resp, 
              `data.release_dates_history[${0}].release_date_audit_cycle.release_date_location.location.location_name`, 
              ""
            );
            setVendorName(vendorName);
            setLocationName(locationName)
            // setVendorName(getValue(resp,`data.release_dates_history[${0}].release_date_audit_cycle.release_date_location.release_date.vendor.vendor_name`, ""))
            setTotalCount(getValue(resp, `data.pagination.total`, 0));
            setIsLoading(false);
          } else {
            setIsLoading(false);
          }
        } catch (error) {
          setIsLoading(false);
        }
      };
    

  /* -------------------------------------------------------------------------- */
  /*                               Pagination section                           */
  /* -------------------------------------------------------------------------- */

  const [totalCount, setTotalCount] = useState(0);
  const [limit, setLimit] = useState(10);

    
  const getTableState = (value: object) => {
      let selectedIndexList = Object.keys(
      getValue(value, `selectedRowIds`, {})
      ).map((item) => parseInt(item));
      let selectedIds =
      vendorHistoryList.length > 0
          ? vendorHistoryList.filter((_item: object, index: number) =>
              selectedIndexList.includes(index)
          )
          : [];
      if (selectedIds.length > 0) {
      setSelectedIDs(
          selectedIds.map((item: object) => getValue(item, `id`, ""))
      );
      } else {
      setSelectedIDs([]);
      }
  };



  const [check, setCheck] = useState(false);
  const [selectedIDs, setSelectedIDs] = useState<any>([]);
  const getTrProps = (rowInfo: any) => {
      if (getValue(rowInfo, `id`, "")) {
      return {};
      }
      return {};
  };

  const columns = React.useMemo(
      () => [
          {
              Header: "Release From",
              accessor: "start_date",
              style: { "white-space": "unset", overflow: "hidden" },
              width: 200,
          },
          {
              Header: "Release To",
              accessor: "cutoff_date",
              style: { "white-space": "unset" },
              width: 200,
          },
          {
            Header: "Release Cycle",
            accessor: "release_cycle",
            style: { "white-space": "unset" },
            width: 200,
        },
          {
              Header: "Added By",
              accessor: "addedBy",
              style: { "white-space": "unset" },
              width: 210,
          },
          {
              Header: "Added On",
              accessor: "created_at",
              style: { "white-space": "unset" },
              width: 150,
          },
        //   {
        //       Header: "Last Modified By",
        //       accessor: "lastModifiedBy",
        //       style: { "white-space": "unset" },
        //       width: 180,
        //   },
          {
              Header: "Last Modified Date",
              accessor: "updated_at",
              style: { "white-space": "unset" },
              width: 150,
          },
          {
            Header: "Action Status",
            accessor: "action",
            width: 120,
        }
      ],
      []
  );

   /* -------------------------------------------------------------------------- */
  /*                               Pagination section                           */
  /* -------------------------------------------------------------------------- */

  const [page_no, setPage_no] = useState(1);

  const handleChangePagination = (page_no: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload = {
      ...params,
      page_no: page_no,
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  const handleChangeLimit = (limit: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      limit: limit,
      page_no: "1",
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };


  
    return (
      <>
        <Layout>
            <div className="common-sticky-header">
                <section className="inner-page-navigation-with-back-cta-buttons position-relative">
                    <div className="container-fluid  d-flex justify-content-between align-items-center">
                        <div className="d-flex align-items-center">
                            <NavLink to="/repository/checkpoint/release-dates-new">
                                <img src="/images/back-link.svg" className="img-fluid" height={24} width={24} />
                            </NavLink>
                            <p className="inner-page-navigation-text py-3">
                                {vendorName} - (<span className="loc-font-color">{locationName}</span>)
                            </p>
                        </div>
                    </div>
                </section>
            </div>
            <div className="vendor-history-table-wrapper">
                
            <div className="only-bottom-borders">
                <ScrollableReactTable
                    columns={columns}
                    data={vendorHistoryList}
                    getTableState={getTableState}
                    selectedIDs={selectedIDs}
                    getTrProps={getTrProps}
                    check={check}
                    checkboxlogo
                />
                </div>
                {totalCount > 10 ? (
                  <PaginationPage
                    totalCount={totalCount}
                    limit={limit}
                    pageNumber={page_no}
                    handleChangePagination={handleChangePagination}
                    handleChangeLimit={handleChangeLimit}
                  />
                ) : (
                  <div className="footer-wrapper d-flex">
                    Total Count:&nbsp;&nbsp;{" "}
                    <p style={{ color: "rgb(13, 110, 253)" }}>{totalCount}</p>
                  </div>
                )}
                {/* <div className="vendor-history-pagination-wrapper">
                    <ReleasePagination />
                </div>
                
                
                <div className="footer-wrapper-new w-100">
                    <img
                        src="/images/footer-image.svg"
                        className="img-fluid footer-image"
                    />
                </div> */}
            </div>
        </Layout>
      </>
    );
}

export default VendorHistory;